<template>
  <div
    class="inline-block rounded-sm border border-color EventChange relative p-1"
    :class="hasDropdown && 'clickable cursor-pointer transition'"

    @click="opened = true"
    v-click-outside="closeDropDown"
  >
    <span class="text-gray-600 p-0.5 rounded-l-sm px-1 font-medium label block">
      <span v-if="hasDropdown">
        <svg :class="opened && 'rotate-180'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="w-3 h-3 transform transition">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
      </span>
      {{ readableLabel }}
    </span>
    <span class="px-1 inline-flex items-center whitespace-nowrap pl-1">
      <span class="text-gray-500 truncate inline-block" :class="hasAtLeastOneBoolean && (old ? 'text-green-700' : 'text-red-700')">
        <span v-if="validOld">{{ validOld }}</span>
        <span v-else class="italic">{{ oldEmptyValue }}</span>
      </span>
      <span class="mx-1">></span>
      <span class="font-semibold truncate inline-block" :class="hasAtLeastOneBoolean && (value ? 'text-green-700' : 'text-red-700')">
        <span v-if="validValue">{{ validValue }}</span>
        <span v-else class="italic">{{ newEmptyValue }}</span>
      </span>
    </span>

    <transition v-if="hasDropdown"
      @enter="enter"
      @leave="leave"
    >
      <ArrayDifference
        v-if="hasAtLeastOneList && opened"

        :extractMostImportantReadableField="extractMostImportantReadableField"
        :value="value"
        :old="old"
      />
      <ObjectDifference
        v-if="hasAtLeastOneComplexObject && opened"
        :value="value"
        :old="old"
      />
    </transition>
  </div>
</template>

<script>

import ArrayDifference from "./ArrayDifferences"
import ObjectDifference from "./ObjectDifference"

import transitionFunctionConstructor from "@/mixins/transitionFunctionConstructor"

export default {
  mixins: [transitionFunctionConstructor()],
  components: {
    ArrayDifference,
    ObjectDifference,
  },
  props: {
    label: String,
    value: {},
    old: {},
  },
  data() {
    return {
      opened: false,
    }
  },
  methods: {
    closeDropDown() {
      this.opened = false
    },
    extractMostImportantReadableField(obj) {
      if (typeof obj === 'string') return obj
      return obj.name || obj.title || obj.domainname || obj.category || obj.value
    },
    isObj(val) {
      return !Array.isArray(val) && typeof val === 'object' && val !== null
    },
    isSimpleObj(val) {
      return Object.keys(val).length === 1
    },
    getVal(val) {
      if (typeof val === "boolean") {
        return val ? "Yes" : "No"
      }

      if (typeof val === "string") {
        try {
          val = JSON.parse(val)
        } catch (err) {}
      }

      if (Array.isArray(val)) {
        return this.readableArray(val)
      }
      const isObject = this.isObj(val)
      if (!isObject) {
        return val
      }

      if (isObject && this.isSimpleObj(val)) {
        return val[Object.keys(val)[0]]
      } else if (isObject) {
        return this.extractMostImportantReadableField(val)
      }

      return val
    },
    readableArray(arr) {
      if (typeof arr[0] === 'string') return arr.join(", ")
      const str = arr.reduce((str, item) => {
        return `${str} ${this.extractMostImportantReadableField(item)},`
      }, "")
      return str.substring(0, str.length - 1)
    },
    getEmptyVal(val, isValueArr) {
      if (typeof val === "boolean" || this.hasAtLeastOneBoolean) return val ? "Yes" : "No"
      return isValueArr ? "empty list" : 'empty'
    },
  },
  computed: {
    newEmptyValue() {
      return this.getEmptyVal(this.validValue, this.isValueArray)
    },
    oldEmptyValue() {
      return this.getEmptyVal(this.validOld, this.isOldArr)
    },
    hasAtLeastOneBoolean() {
      return typeof this.value === "boolean" || typeof this.old === 'boolean'
    },
    readableLabel() {
      const label = this.label.replace(/_/g, " ")
      return label[0].toUpperCase() + label.substring(1)
    },
    hasDropdown() {
      return this.hasAtLeastOneList || this.hasAtLeastOneComplexObject
    },
    hasAtLeastOneComplexObject() {
      return (this.isObj(this.value) && !this.isSimpleObj(this.value)) || this.isObj(this.old) && !this.isSimpleObj(this.old)
    },
    hasAtLeastOneList() {
      return this.isValueArray || this.isOldArr
    },
    isValueArray() {
      // "[]" is necessary because of a backend problem.
      return Array.isArray(this.value) || this.value === '[]'
    },
    isOldArr() {
      // "[]" is necessary because of a backend problem.
      return Array.isArray(this.value) || this.value === '[]'
    },
    validValue() {
      return this.getVal(this.value)
    },
    validOld() {
      return this.getVal(this.old)
    },
  },
}

</script>

<style scoped>

.EventChange {
  font-size: 12px;
}

.border-color {
  border-color: rgb(245,245,245) !important
}

.border-color.clickable:hover {
  border-color: rgb(220,220,220) !important
}

.truncate {
  max-width: 180px;
}

.label {
  border-right-width: 1px !important;
  border-top-width: 0px !important;
  border-bottom-width: 0px !important;
  border-left-width: 0px !important;
}

</style>
